// Page content comes from the customer's Notion workspace. The markdown is
// rendered through the shared markdown renderer, which escapes HTML; the URL is
// untrusted and only safe in an href.

import { isString } from "../utils/schemaUtils";

export interface NotionPagePayload {
  type: "notion_page";
  pageId: string;
  title: string;
  url: string;
  markdown: string;
  // The body hit Notion's render cap, so the tail is missing.
  truncated?: boolean;
}

export const parseNotionPagePayload = (v: unknown): NotionPagePayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "notion_page") return null;
  if (!isString(r.pageId)) return null;
  if (!isString(r.title)) return null;
  if (!isString(r.url)) return null;
  if (!isString(r.markdown)) return null;
  return {
    type: "notion_page",
    pageId: r.pageId,
    title: r.title,
    url: r.url,
    markdown: r.markdown,
    truncated: r.truncated === true,
  };
};
